module.exports = __webpack_public_path__ + "res/landing_a_ar.683deb37437e5352e17d1b1a7f97c161.mp4";